module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "title": "Acknowledgments"
    }
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#rack"
    }
  }, [_c('b', [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("I’d like to acknowledge")]), _vm._v(" Tom Dean, VP of Marketing at Zondervan, for reaching out to me to consider writing a book to share my story. Without his prompting, this book never would have happened. I’d also like to acknowledge my friend Pastor Matthew Barnett, who pastors the Dream Center in Los Angeles and took me on the craziest weeklong adventure of my life, and connected me with the wonderful people at The Fedd Agency to make this book become a reality. And to the wonderful staff at Zondervan, thanks for helping turn a runner into an author through some serious editing throughout the process. Writing a book is like running a marathon. There may be only one person out there running the race or writing the book, but there is a huge team behind that person, which makes all the difference. Thanks to my team who “ran the race” with me."), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e2d6258","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780310354390_Acknowledgments.vue
// module id = 72
// module chunks = 0